import { io } from "socket.io-client";
const URL = process.env.REACT_APP_ON_PREM_POINT ?? "";

const createSocketConnection = (location: any) => {
  const socket = io(URL, {
    path: "/socket.io",
    query: { location },
  });
  return socket;
};
export default createSocketConnection;
